<template><div></div></template>

<script>
import apiFactory from '@/modules/entity/api';
import StorableEditorComponent from '@/mixins/storable-editor-component';

export default {
  name: 'nx-entity-preview-paywall-action',
  mixins: [StorableEditorComponent],
  data() {
    return {
      loading: false,
      active: false,
    };
  },
  computed: {
    hasUrlSelected() {
      return this.getters.hasUrlSelected;
    },
  },
  methods: {
    async handleClone() {
      try {
        this.$emit('loading', true);
        const api = apiFactory('sitePaywall');
        const { redirectUrl } = await api.previewPaywall(this.state.draft.entityId, this.state.draft.versionId);
        window.open(redirectUrl);
      } catch (e) {
        this.toast.notify('message.error.serverError');
        console.error(e);
      } finally {
        this.$emit('close');
        this.$emit('loading', false);
      }
    },
  },
  mounted() {
    this.handleClone();
  },
};
</script>
